import { withPlaceholder } from '../../Placeholders';
import { TextFieldPlaceholder } from '../../Placeholders/Templates';
import { TextField } from '..';

export default withPlaceholder({
    customPlaceholder: TextFieldPlaceholder
})(TextField);
